module.exports = __webpack_public_path__ + "img/icon_face_verify.5ed0c309.png";